import { render, staticRenderFns } from "./ListSortingArrows.vue?vue&type=template&id=46f1bf00&"
import script from "./ListSortingArrows.vue?vue&type=script&lang=js&"
export * from "./ListSortingArrows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports